module.exports = __webpack_public_path__ + "static/media/ForParents_Icon.27e45c89.png";